import { SET_CURRENT_PLANET } from '../action/action.config'
import BlueIcon from 'assets/icons/blue-icon.svg'
import GreenIcon from 'assets/icons/green.png'
import GreenIconNoShadow from 'assets/icons/green_planet_no_shadow.png'
import BlueMenuIcon from 'assets/icons/blue_menu_mob.svg'
//import GreenMenuIcon from 'assets/icons/green_planet_no_shadow.svg'
import GreenMenuIcon from 'assets/icons/green_menu_mob.svg'
import BluBgIcon from 'assets/icons/bg-planet-icon.png'

const initialState = {
    currentPlanet: "blue",
    planetIcon: BlueIcon,
    menuIcon: BlueMenuIcon,
    bgIcon: BluBgIcon
}

const getPlanetIcon = (currPlanet: string) => {
    let planetIconVal = BlueIcon
    if (currPlanet === 'green') {
        planetIconVal = GreenIcon
    }
    return planetIconVal
}
const getMenuIcon = (currPlanet: string) => {
    let menuIconVal = BlueMenuIcon
    if (currPlanet === 'green') {
        menuIconVal = GreenMenuIcon
    }
    return menuIconVal
}
const getBgIcon = (currPlanet: string) => {
    let bgIconVal = BluBgIcon
    if (currPlanet === 'green') {
        bgIconVal = GreenIcon
    }
    return bgIconVal
}

export const planetReducer = (state = initialState, action: any) => {
    const { type, payload } = action
    switch (type) {

        case SET_CURRENT_PLANET:
            return {
                ...state,
                currentPlanet: payload,
                planetIcon: getPlanetIcon(payload),
                menuIcon: getMenuIcon(payload),
                bgIcon: getBgIcon(payload)
            }
        default:
            return state
    }
}
